import {
    INIT_REPORT_REQUEST,
    ADD_REPORT,
    ERROR_REPORT_REQUEST,
    ADD_MACHINE_BY_COMPANYID_FOR_REPORT
} from './action';

const initialState = {
    // data: [],
    error: null,
    isLoading: false,
    machineByCompanyIdforreport: [],
    reportUrl: null,
};

const reportReducer = (state = initialState, action) => {
    switch (action.type) {
        case INIT_REPORT_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };


        case ADD_REPORT:
            return {
                ...state,
                reportUrl: action.payload,
                isLoading: false,
                error: null,
            };

        case ERROR_REPORT_REQUEST:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        case ADD_MACHINE_BY_COMPANYID_FOR_REPORT:
            return {
                ...state,
                isLoading: false,
                machineByCompanyIdforreport: action.payload,
                error: null
            };
        default:
            return state;
    }
};

export default reportReducer;
